import CryptoJS from 'crypto-js';
export class ReviewService {
    cachedReviewsKey = "git_reviews";
    reviewApi;
    authService;
    constructor(api, authService) {
        this.reviewApi = api;
        this.authService = authService;
    }
    fetchReviews(count) {
        return this.reviewApi.getReviews(0, count);
    }
    fetchProductReviews(productId, page, count) {
        return this.reviewApi.getProductReview(productId, page, count);
    }
    getProductReviews(productId, page, count) {
        const cachedReviews = this.getCachedSessionProductReviewsInterval(productId, page, count);
        if (cachedReviews && cachedReviews.length > 0) {
            return {
                page: page,
                count: cachedReviews.length,
                data: cachedReviews
            };
        }
        return undefined;
    }
    storeProductReviews(productId, reviews) {
        const sessionKey = this.authService.getSessionKey();
        if (!sessionKey) {
            return;
        }
        this.saveCachedSessionProductReviews(productId, reviews, sessionKey);
    }
    getCachedSessionProductReviewsInterval(productId, page, count) {
        const sessionKey = this.authService.getSessionKey();
        if (!sessionKey) {
            return;
        }
        const cachedReviews = this.getCachedSessionProductReviews(productId, sessionKey);
        if (!cachedReviews) {
            return undefined;
        }
        const length = cachedReviews.length;
        const startIndex = page * count;
        const endIndex = length < (page + 1) * count ? length : (page + 1) * count;
        return cachedReviews.slice(startIndex, endIndex);
    }
    getCachedSessionProductReviews(productId, sessionKey) {
        try {
            const key = `${this.cachedReviewsKey}_${productId}`;
            const storedReviews = sessionStorage.getItem(key);
            if (!storedReviews) {
                return undefined;
            }
            const bytes = CryptoJS.AES.decrypt(storedReviews, sessionKey);
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
        catch (e) {
            return undefined;
        }
    }
    saveCachedSessionProductReviews(productId, reviews, sessionKey) {
        const key = `${this.cachedReviewsKey}_${productId}`;
        const storedReviews = this.getCachedSessionProductReviews(productId, sessionKey);
        let reviewsToCache = reviews;
        if (storedReviews) {
            reviewsToCache = Array.from(new Map([...storedReviews, ...reviews].map(review => [review.id, review])).values());
        }
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(reviewsToCache), sessionKey).toString();
        sessionStorage.setItem(key, encryptedData);
    }
}
